export default __webpack_public_path__ + "static/media/printer-dark.7f8795cf.svg";